// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-search[data-v-0db189af] {\n  position: relative;\n}\n.input-icon[data-v-0db189af] {\n  position: absolute;\n  top: 8px;\n  left: 10px;\n}\n.clear-icon[data-v-0db189af] {\n  left: auto;\n  right: 10px;\n}\n.input-icon[data-v-0db189af] .svg-icon {\n  width: 20px;\n  height: 20px;\n  fill: #9b9b9b;\n}\ninput[data-v-0db189af] {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.Vlt-form__element *[data-v-0db189af] {\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
